export default __webpack_public_path__ + "images/left-arrow.svg?7c46f54c628ffe660feebaff8a62fdbb";